module.exports = __webpack_public_path__ + "static/video-3-6efddcc69df717370241f69fcbc15106.mp4";